import React, { useMemo } from 'react';
import './sideFilterBoolean.less';
import { Checkbox, Skeleton, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { updateModalSideFilters, updateSiteFilter } from '../../../../modules/SearchDatePicker/searchDatePickerSlice';
import { BooleanFilter } from '../../interface';
import useGetAttributeTranslation from '../../hooks/useGetAttributeTranslation';

interface Props {
  filter: BooleanFilter;
  withModalScopeParams?: boolean;
  isLoading?: boolean;
  additionalPrice?: number;
    localSideFilters?: Record<string, any> | null;
  setLocalSideFilters?: (f: Record<string, any>) => void;
}
const SideFilterBoolean = ({ filter,
  withModalScopeParams,
  isLoading,
  additionalPrice = 0,
    localSideFilters,
  setLocalSideFilters
 }: Props) => {
  const dispatch = useDispatch();
  const { sideFilters: reduxSideFilters, modalSideFilters } = useSelector(
    (state: RootState) => {
      return state.search;
    }
  );
  const sideFilters = useMemo(
    () => (localSideFilters ? localSideFilters : withModalScopeParams
      ? modalSideFilters
      : reduxSideFilters),
    [withModalScopeParams, modalSideFilters, reduxSideFilters, localSideFilters]
  );

  // helper that updates either local filters (if provided) or redux
  const commitFilter = (key: string, value: any) => {
    if (setLocalSideFilters) {
      // update local copy immutably
      setLocalSideFilters({
        ...(localSideFilters || {}),
        [key]: value,
      });
      return;
    }
    const fn = withModalScopeParams ? updateModalSideFilters : updateSiteFilter;
    dispatch(fn({ key: filter.attr, value: value ? 1 : undefined }));
  };

    const handleChange = (newValue: boolean) => {
        commitFilter(filter.attr, newValue);
    };

  const { general: t } = useSelector(
    (state: RootState) => state.config.translations
  );
  const attributeTranslation = useGetAttributeTranslation();

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 1 }} />;
  }

  return (
    <div className="side-filter-boolean">
      <h2>{attributeTranslation(filter.attr)}</h2>
      <Switch
        // checkedChildren={attributeTranslation(filter.attr + "_checked")}
        onChange={handleChange}
        checked={sideFilters?.[filter.attr]?.[0]}
      />
    </div>
  );
};

export default SideFilterBoolean;
